import { SgdfParticipantItem } from './ParticipantItem.js';
window.customElements.define('sgdf-participant-item', SgdfParticipantItem);
//# sourceMappingURL=sgdf-participant-item.js.map